import { PrivateOutlet } from '@/outlets/private-outlet';
import { ReferenceDataOutlet } from '@/outlets/reference-data-outlet';
import { Route } from '@/util/react-router-dom';
import { profileCreationRoutes } from './profile-creation';
import { visitRoutes } from './visit';
import { DashboardPage } from '@/pages/dashboard/dashboard-page';
import { PatientDetailsConfirmation } from '@/pages/patient-details-confirmation/patient-details-confirmation-page';
import { Layout } from '@/components/layout';

export const privateRoutes = (
  <Route element={<PrivateOutlet />}>
    <Route element={<ReferenceDataOutlet />}>
      {profileCreationRoutes}

      <Route path="" Component={DashboardPage} />
      <Route element={<Layout simplified />}>
        <Route path="details-confirmation" element={<PatientDetailsConfirmation />} />
      </Route>

      {visitRoutes}
    </Route>
  </Route>
);
